import { inject, Injectable, signal } from '@angular/core';
import { ReadonlyRepositoryListService } from '@softline/core';
import { TasksRepository } from '../repositories/tasks.repository';
import { Task } from '../types/task';
import { TaskState } from '../types/task-state';

@Injectable()
export class TasksService extends ReadonlyRepositoryListService<
  Task,
  Task,
  { status?: TaskState; types?: string } | null
> {
  protected override repository = inject(TasksRepository);

  constructor() {
    super(inject(TasksRepository));
  }

  params = signal(null); //TODO: { status: TaskState.U, types: 'AufgabeMail' });

  getItems(result: any): any {
    return result ?? undefined;
  }

  setParams(params: any): void {
    this.params.set(params);
  }
}
